import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, inject, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CompanyInterface } from '@app/interface/company';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { CompanyApi } from '@app/services/company-api';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { TypeOptions } from '@app/interface/type-options';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogData } from '@app/new-company/new-company.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-confirm-delete-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSnackBarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
  standalone: true,
  templateUrl: './confirm-delete-dialog.component.html',
  styleUrl: './confirm-delete-dialog.component.scss',
})
export class ConfirmInvoiceDeleteComponent {
  confirmed = false;
  title = '';
  message = '';
  checkboxLabel = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmInvoiceDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Set default values or use provided data
    this.title = data.title || 'Elimina';
    this.message = data.message || 'Sicuro di voler eliminare?';
    this.checkboxLabel =
      data.checkboxLabel || 'Confermo di voler eliminare la fattura e accetto';
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
